const entryProfilesTutorial = {
  module: 'entry_profiles',
  moduleName: 'Entry Profiles',
  steps: [
    { target: '.entry-header', position: 'bottom', title: 'Config Profiles', description: 'Create and manage tablet configuration templates.' },
    { target: '.entry-header-actions .btn-primary', position: 'bottom', title: 'New Profile', description: 'Define settings that can be pushed to multiple tablets.' },
    { target: '.entry-profile-grid', position: 'top', title: 'Profile Cards', description: 'Each card represents a configuration template with its assigned devices.' },
  ],
};
export default entryProfilesTutorial;
